import type { EcommerceShowtimeItem } from '../models-gtm'

export const groupShowtimeItemsByQuantity = (showtimeItems: EcommerceShowtimeItem[], groupConcessions: boolean) => {
    const groupedShowtimeItems: EcommerceShowtimeItem[] = []
    showtimeItems.forEach(showtimeItem => {
        // item_id is filmId for tickets so we should use item_variant to group them
        const existingShowtimeItem = groupedShowtimeItems.find(
            item =>
                (groupConcessions && item.item_id === showtimeItem.item_id) ||
                (!groupConcessions && item.item_variant === showtimeItem.item_variant)
        )
        if (!existingShowtimeItem && !!showtimeItem?.quantity) {
            groupedShowtimeItems.push(showtimeItem)
            return
        }

        if (!existingShowtimeItem?.quantity || !showtimeItem.quantity) return
        existingShowtimeItem.quantity += showtimeItem.quantity
    })

    return groupedShowtimeItems
}
